// Saved Runs — history browser
import { api } from './api.js';

let _runs = [];
let _currentRun = null;

export function init() {
  document.getElementById('btn-history-refresh')?.addEventListener('click', loadRuns);
  document.getElementById('history-filter')?.addEventListener('change', loadRuns);
  document.getElementById('btn-history-back')?.addEventListener('click', showList);
  document.getElementById('btn-history-export')?.addEventListener('click', exportCurrent);
}

export async function loadRuns() {
  const filter = document.getElementById('history-filter')?.value || '';
  const list = document.getElementById('history-list');
  const detail = document.getElementById('history-detail');
  if (!list) return;
  detail?.classList.add('hidden');
  list.classList.remove('hidden');
  list.innerHTML = '<div class="history-empty">Loading...</div>';

  const res = await api.listRuns(filter);
  if (!res.success) {
    list.innerHTML = `<div class="history-empty">${res.error || 'Failed to load'}</div>`;
    return;
  }

  _runs = res.data || [];
  if (!_runs.length) {
    list.innerHTML = '<div class="history-empty">No saved runs yet</div>';
    return;
  }

  list.innerHTML = _runs.map(r => `
    <div class="history-item" data-id="${r.id}">
      <div class="history-item-info">
        <span class="history-item-module">${esc(r.module)}</span>
        <span class="history-item-scan">${esc(r.scanType)}</span>
        <span class="history-item-rows">${r.rows?.length || 0} rows</span>
      </div>
      <div class="history-item-meta">
        <span class="history-item-date">${r.savedAt ? new Date(r.savedAt).toLocaleString() : ''}</span>
        <button class="btn btn-sm btn-danger history-del" data-id="${r.id}" title="Delete"><i class="fas fa-trash"></i></button>
      </div>
    </div>
  `).join('');

  list.querySelectorAll('.history-item').forEach(el => {
    el.addEventListener('click', e => {
      if (e.target.closest('.history-del')) return;
      showDetail(el.dataset.id);
    });
  });

  list.querySelectorAll('.history-del').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.stopPropagation();
      const id = btn.dataset.id;
      if (!confirm('Delete this saved run?')) return;
      await api.deleteRun(id);
      loadRuns();
    });
  });
}

function showDetail(id) {
  const run = _runs.find(r => r.id === id);
  if (!run) return;
  _currentRun = run;

  document.getElementById('history-list')?.classList.add('hidden');
  const detail = document.getElementById('history-detail');
  detail?.classList.remove('hidden');

  document.getElementById('history-detail-title').textContent =
    `${run.module} / ${run.scanType} — ${new Date(run.savedAt).toLocaleString()}`;

  const table = document.getElementById('history-detail-table');
  const thead = table.querySelector('thead');
  const tbody = table.querySelector('tbody');

  thead.innerHTML = '<tr>' + (run.headers || []).map(h => `<th>${esc(h)}</th>`).join('') + '</tr>';
  tbody.innerHTML = (run.rows || []).map(row =>
    '<tr>' + row.map(c => `<td>${esc(String(c))}</td>`).join('') + '</tr>'
  ).join('');
}

function showList() {
  _currentRun = null;
  document.getElementById('history-detail')?.classList.add('hidden');
  document.getElementById('history-list')?.classList.remove('hidden');
}

function exportCurrent() {
  if (!_currentRun) return;
  let csv = _currentRun.headers.join(',') + '\n';
  for (const row of _currentRun.rows)
    csv += row.join(',') + '\n';
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  a.download = `${_currentRun.module}_${_currentRun.scanType}.csv`;
  a.click();
}

function esc(s) {
  const d = document.createElement('div');
  d.textContent = s || '';
  return d.innerHTML;
}
